import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoaderComponent } from '@modules/shared/loader/loader.component';
import { HttpCustomErrorCode } from '@pixacare/shared';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';
import { Status } from '@shared/models/enums/status.enum';
import { TuiButton, TuiTitle } from '@taiga-ui/core';
import { map } from 'rxjs';

@Component({
  selector: 'pxc-authentication-error',
  imports: [CommonModule, TranslocoDirective, TuiButton, TuiTitle, LoaderComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './authentication-error.component.html',
})
export class AuthenticationErrorComponent {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private readonly authAppRedirectService = inject(AuthAppRedirectService);

  error$ = this.route.queryParams.pipe(map((params) => params.error));

  readonly HttpCustomErrorCode = HttpCustomErrorCode;
  readonly Status = Status;

  // Home, not back here: the default return is this error page.
  login(): void {
    this.authAppRedirectService.login('/home');
  }
}
